import './AcademicLibraryContainer.css'
import ContentCreator from '../../../../components/ContentCreator/ContentCreator'
import AcademicLibraryForm from '../AcademicLibraryForm/AcademicLibraryForm';
import TanStackTable from '../../../../components/Table/TanStackTable/TanStackTable';
import useLibrary from '../../../../hooks/Academic/Library/useLibrary';
import { Flex, Image } from '@mantine/core';
import AcademicLibraryPreview from '../AcademicLibraryPreview/AcademicLibraryPreview';
import DeleteConfirmationModal from '../../../../components/DeleteConfirmationModal/DeleteConfirmationModal';


export default function AcademicLibraryContainer() {


   const {
      displayForm,
      setDisplayForm,
      initialValuesEdit,
      setInitialValuesEdit,
      libraryData,
      columns,
      loading,
      editContentLibrary,
      deleteContentLibrary,
      deleteModalOpen,
      setDeleteModalOpen,
      selectedContentId,
      setSelectedContentId,
      handleSubmit } = useLibrary()

   return (
      <section className='AcademicContent-main-container'>

         {displayForm && (
            <ContentCreator
               title={initialValuesEdit ? "Editar contenido" : "Crear contenido"}
               submitFunc={(values) => handleSubmit(values)}
               onCancel={() => {
                  setDisplayForm(false);
                  setInitialValuesEdit(null);
               }}
               initialValues={initialValuesEdit ?? null}
               renderPreview={(_form) => (
                  <AcademicLibraryPreview form={_form} />
               )}
               renderForm={(_form) => (
                  <AcademicLibraryForm form={_form.form} loading={loading} />
               )}
            />
         )}
         <TanStackTable
            data={libraryData}
            columns={columns}
            editFunc={editContentLibrary}
            onDelete={deleteContentLibrary}
            displayForm={displayForm}
            addButtonFunc={() => {
               setDisplayForm(!displayForm);
               if (displayForm) setInitialValuesEdit(null);
            }}
         />

         <DeleteConfirmationModal
            opened={deleteModalOpen}
            loading={loading}
            onClose={() => {
               setDeleteModalOpen(false)
               setSelectedContentId(null)
            }}
            onCancel={() => {
               setDeleteModalOpen(false)
               setSelectedContentId(null)
            }}
            onConfirm={deleteContentLibrary}
         />

      </section>
   )
}